import type { PMCard } from "@ka-nabellinc/tcg-platform-es-schema";
import type { NumInCart } from "./types";
import type { PokemonCartItem } from "@/types/cart";

export const getDefaultFields = () => ({
  rankSInventoryNum: 0,
  rankAInventoryNum: 0,
  rankBInventoryNum: 0,
  rankCInventoryNum: 0,
});

export const getNumInCart = (
  items: PokemonCartItem[],
  inventoryProductId: string
): NumInCart => {
  const sameProductItems = items.filter(
    (item) =>
      item.productType === "single" &&
      item.product.inventory_product_id === inventoryProductId
  );
  const rankSItem = sameProductItems.find((item) => item.rank === "s");
  const rankAItem = sameProductItems.find((item) => item.rank === "a");
  const rankBItem = sameProductItems.find((item) => item.rank === "b");
  const rankCItem = sameProductItems.find((item) => item.rank === "c");

  return {
    total: sameProductItems.reduce((acc, ac) => acc + ac.orderNum, 0),
    s: rankSItem ? rankSItem.orderNum : 0,
    a: rankAItem ? rankAItem.orderNum : 0,
    b: rankBItem ? rankBItem.orderNum : 0,
    c: rankCItem ? rankCItem.orderNum : 0,
  };
};

export const getCardInfoString = (card: PMCard) => {
  let infoString = "";

  if (card.pack.expansion_mark) {
    infoString += `[${card.pack.expansion_mark}]`;
  }

  if (card.collection_number) {
    infoString += `[${card.collection_number}]`;
  }

  infoString += `[${card.rarity.rarity_abbreviation}]`;

  return infoString;
};
